
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.84 52.713c-12.409 0-22.497-10.046-22.497-22.4 0-12.356 10.088-22.401 22.496-22.401s22.497 10.045 22.497 22.4c0 12.355-10.089 22.4-22.497 22.4zm0-42.81c-11.299 0-20.498 9.16-20.498 20.41s9.199 20.409 20.497 20.409c11.299 0 20.497-9.16 20.497-20.41S41.148 9.903 29.84 9.903z"}}),_c('path',{attrs:{"d":"M39.108 31.308H20.58a1 1 0 01-1-.996 1 1 0 011-.995h18.527a1 1 0 011 .995 1 1 0 01-1 .996z"}})])
          )
        }
      }
    